<template>
    <div class="grcform">
    <GrcDB ref="GRCDB"></GrcDB>    
    <GrcDialog ref="Dialog"
        v-on:popupopened="SetPopupRef('Dialog')"
        v-on:popupclosed="SetPopupRef('')"
    ></GrcDialog>

    <div style="width:100%; box-sizing:border-box; padding-bottom: 0px; margin-bottom: 20px; display: inline-block;">
      <div style="width:100%; box-sizing:border-box;">
            <div class="igeny_pageheader">
                <div class="igeny_pageheader_col1">
                    <div class="grc_sectionheader" style="margin-top:0px;">
                        <h2 class="painted_header_h2 color3"><span><b>Molekuláris diagnosztika</b></span></h2>
                    </div>
                </div>
                <div class="igeny_pageheader_col2">
                    <span class="painted_linkbutton2 color4"><span>{{UgyfelNev}}</span></span>
                </div>
            </div>

      </div>
    </div>

    <div style="width:100%; box-sizing:border-box; text-align:left;" v-show="IsEnabled==0" v-html="DisabledText">
        
    </div>

    <div style="width:100%; box-sizing:border-box; text-align:left;" v-show="(IsEnabled==1)&&(MainStep==0)">
        <div style="width:100%; box-sizing:border-box; text-align:justify;" v-html="MainStep0_infotext">
            
        </div>

        <div class="btncont" style="margin-top:30px;">

            <span @click="GoTo_MainStep(1)" class="painted_linkbutton2 color3"><span>Igénybejelentés<i class='fal fa-chevron-right' style="margin-left:10px;"></i></span></span>                    

        </div>

    </div>

    <div style="width:100%; box-sizing:border-box;" v-show="(IsEnabled==1)&&(MainStep==1)">
      <div style="padding-bottom: 20px; width:100%; box-sizing:border-box;">

        <div class="igeny_pagecontent">

            <div class="innerform_cont">
                <span class="painted_linkbutton2 color4"><span>Időpontok megadása</span></span>
                <br><br>

                <div class="infotext" style="margin-bottom:10px;">

                    <div class="general_infotext" style="margin:10px 0px; text-align:justify;">
                        Adjon meg legalább 5 különböző napot, amikor alkalmas Önnek a szolgáltatás igénybevétele. 
                        Egyszerre több napot is kijelölhet a kezdő és a záró dátum megadásával. 
                        Legkorábbi kezdő dátum amit megadhat, a bejelentést követő 5. nap lehet.
                    </div>

                </div>

                <div class="general_infotext" style="text-align:center; text-align: center; margin-bottom: 10px; font-weight:500;" >
                    <span class="painted_linkbutton2 color4"><span><i class="fal fa-calendar-alt" style="margin-right:10px;"></i>Időpontok listája</span></span>
                </div>

                <div class="general_infotext" style="text-align:center; text-align: center; margin-bottom: 20px;" v-show="Idopontok.length==0&&IdopontInputMode==0">
                    A lista még üres
                </div>

                <div class="idopont_cont" v-show="Idopontok.length>0">
                    <div class="idopont_item" v-for="(idopont, idopontindex) in Idopontok">
                        <table class="idopont_item_text" cellspacing="0" cellpadding="0">
                            <tr>
                                <td>
                                    <span style="margin-right:20px;">
                                        {{idopont.DatumTol}} - {{idopont.DatumIg}}
                                    </span>
                                    <span>
                                        {{idopont.TimeTol}} - {{idopont.TimeIg}}
                                    </span>
                                </td>
                                <td style="width:30px; text-align:center; cursor:pointer; color:red;" @click="IdopontTorles(idopontindex)">
                                    <i class="far fa-times-circle"></i>
                                </td>

                            </tr>
                        </table>
                    </div>
                </div>

                <div class="btncont" style="text-align: center; margin: 10px 0px;" v-show="IdopontInputMode==0">
                    <span @click="btnIdopont_Uj_click" class="painted_linkbutton2 color3" style="margin:4px;"><span><i class='fal fa-plus' style="margin-right:10px;"></i>Új időpont hozzáadás</span></span>
                </div>


                <div ref="IdopontInput" class="UjIdopont_cont" v-show="IdopontInputMode>0">

                    <div class="IdopontInput_row">
                
                        <GrcDate ref="txtDatumTol" v-model="txtDatumTol" grc_dateformat="ymd" grc_sep="." 
                        grc_labeltext="Kezdő dátum:" grc_labelmode="" grc_labelwidth="200px" grc_readonly="false"
                        grc_onlydropdown="true"
                        v-on:grc-keydown-enter="SetControlToFocus('txtDatumIg');"
                        v-on:dropdownopened="SetPopupRef('txtDatumTol')"
                        v-on:onlydropdownclosed="txtDatumTol_OnInput"
                        
                        class="UjIdopont_mezo"
                        />

                        <GrcDate ref="txtDatumIg" v-model="txtDatumIg" grc_dateformat="ymd" grc_sep="." 
                        grc_labeltext="Záró dátum:" grc_labelmode="" grc_labelwidth="200px" grc_readonly="false"
                        grc_onlydropdown="true"
                        v-on:grc-keydown-enter="SetControlToFocus('cboTimeTol');"
                        v-on:dropdownopened="SetPopupRef('txtDatumIg')"
                        v-on:onlydropdownclosed="txtDatumIg_OnInput"
                        class="UjIdopont_mezo"
                        />
                    </div>

                    <div class="IdopontInput_row">

                        <GrcCombo ref="cboTimeTol" v-model="TimeTol" grc_labeltext="Kezdő időpont:"
                        grc_labelmode="above" grc_labelwidth="80px" grc_dropdownminwidth="0"  
                        grc_keyfield="id" grc_displayfield="Megnevezes"
                        grc_readonly="false"
                        v-bind:grc_dropdown_columns="[{fieldname:'Megnevezes', width:'100%', cutlongtext:'true'}]"
                        v-on:dropdownopened="SetPopupRef('cboTimeTol')"
                        v-on:dropdownclosed="SetPopupRef('')"
                        v-on:grc-keydown-enter="SetControlToFocus('cboTimeIg');"
                        class="UjIdopont_mezo"
                        />

                        <GrcCombo ref="cboTimeIg" v-model="TimeIg" grc_labeltext="Záró időpont:"
                        grc_labelmode="above" grc_labelwidth="80px" grc_dropdownminwidth="0"  
                        grc_keyfield="id" grc_displayfield="Megnevezes"
                        grc_readonly="false"
                        v-bind:grc_dropdown_columns="[{fieldname:'Megnevezes', width:'100%', cutlongtext:'true'}]"
                        v-on:dropdownopened="SetPopupRef('cboTimeIg')"
                        v-on:dropdownclosed="SetPopupRef('')"
                        v-on:grc-keydown-enter="SetControlToFocus('');"
                        class="UjIdopont_mezo"
                        />
                    </div>

                    <div class="btncont" style="margin-top:30px;">

                        <span @click="btnIdopontMentes" class="painted_linkbutton2 color3" style="margin:4px;"><span><i class='fal fa-check' style="margin-right:10px;"></i>Hozzáadás</span></span>

                        <span @click="btnIdopontMegsem" class="painted_linkbutton2 color7" style="margin:4px;"><span>Mégsem</span></span>

                    </div>

                </div>
    

                <div class="btncont" style="margin-top:50px;" v-show="IdopontInputMode==0">

                    <span @click="GoTo_MainStep(0)" class="painted_linkbutton2 color7" style="margin:4px;"><span><i class='fal fa-chevron-left' style="margin-right:10px;"></i>Vissza</span></span>                    

                    <span @click="btnMentes" class="painted_linkbutton2 color3" style="margin:4px;"><span><i class='fal fa-check' style="margin-right:10px;"></i>Mentés</span></span>
                </div>
            </div>



        </div> <!-- igeny_pagecontent -->

      </div>
    </div>





    
    </div>
</template>

<script>
import axios from "axios";
import GrcButton from '../GrcComponents/GrcButton.vue'
import GrcDB from '../GrcComponents/GrcDB.vue'
import GrcDialog from '../GrcComponents/GrcDialog.vue'
import GrcCombo from '../GrcComponents/GrcCombo.vue'
import GrcText from '../GrcComponents/GrcText.vue'
import GrcDate from '../GrcComponents/GrcDate.vue'

export default {
  name: 'frmdaganat_sos_igenyles',
  components: {
      GrcButton,
      GrcDB,
      GrcDialog,
      GrcCombo,
      GrcText,
      GrcDate,

  },
  props: {
  },
  data () {
      return {
          WSPREFIX: "frmMolekularisDiag_Igenyles_",
          UgyfelID:0,
          UgyfelNev:"",

          IsEnabled:-1,
          DisabledText:"",

          txtDatumTol:"",
          txtDatumIg:"",
          TimeTol:0,
          TimeIg:0,

          IdopontInputMode:1,
          Idopontok:[],

        MinDate: "",
        MaxDate:"",

        MainStep:0,
        MainStep0_infotext:"",

        
      }
  },
  model: {
  },  
  methods:{

    GoTo_MainStep(pValue)
    {
        this.MainStep = pValue;
        this.scrollToTop();
    },

    txtDatumTol_OnInput(pNewValue)
    {
        this.SetPopupRef('');
        var MD = this.MinDate;
        if (pNewValue != "") { MD = pNewValue; }

        this.$refs.txtDatumIg.SetMinMaxDate(MD, this.MaxDate);

        //console.log("tol: "+pNewValue);
    },

    txtDatumIg_OnInput(pNewValue)
    {
        this.SetPopupRef('');

        var MD = this.MaxDate;
        if (pNewValue != "") { MD = pNewValue; }

        this.$refs.txtDatumTol.SetMinMaxDate(this.MinDate, MD);

        //console.log("ig: "+pNewValue);
    },

    SetPopupRef(pRef)
    {
        gPopupControlName = pRef;
    },

    scrollToTop() { window.scrollTo(0,0); },


    GetTextBookItem(pCompName)
    {
        return grcmain_GetTextBookItem("frmMolekularisDiag_Igenyles", pCompName);
    },

    SetLang()
    {
        this.MainStep0_infotext = this.GetTextBookItem("MainStep0_infotext");
    },

      SetControlToFocus(pNextComp)
      {
          if (pNextComp == "") { return; }
        this.$refs[pNextComp].SetFocus();
      },


    btnIdopont_Uj_click()
    {
        this.$refs.txtDatumTol.SetText("");
        this.$refs.txtDatumIg.SetText("");
        this.$refs.cboTimeTol.SetValue(0);
        this.$refs.cboTimeIg.SetValue(0);
        this.$refs.txtDatumTol.SetMinMaxDate(this.MinDate, this.MaxDate);
        this.$refs.txtDatumIg.SetMinMaxDate(this.MinDate, this.MaxDate);
        this.IdopontInputMode = 1;
    },

    btnIdopontMentes()
    {
        if ((this.$refs.txtDatumTol.GetText() == "")||(this.$refs.txtDatumIg.GetText() == ""))
        {
            this.ShowResult("A dátumok megadása kötelező!", 200);
            return;
        }

        if (this.$refs.txtDatumTol.IsValid(false) == false)
        {
            this.ShowResult("A kezdő dátum helytelen!", 200);
            return;
       }

        if (this.$refs.txtDatumIg.IsValid(false) == false)
        {
            this.ShowResult("A záró dátum helytelen!", 200);
            return;
       }

        if ((this.$refs.cboTimeTol.GetValue() == 0)||(this.$refs.cboTimeIg.GetValue() == 0))
        {
            this.ShowResult("Az időpontok megadása kötelező!", 200);
            return;
        }

        if (this.$refs.cboTimeIg.GetValue() - this.$refs.cboTimeTol.GetValue() < 6)
        {
            this.ShowResult("Kérjük legalább 3 órás időszakot adjon meg!", 200);
            return;
        }



        var DTOL = this.$refs.txtDatumTol.GetText();
        var DIG = this.$refs.txtDatumIg.GetText();

        var TTOL = this.$refs.cboTimeTol.GetText();
        var TIG = this.$refs.cboTimeIg.GetText();


        if (DTOL.localeCompare(DIG) == 1)
        {
            this.ShowResult("A dátumok megadása helytelen!", 200);
            return;
        }

        if (TTOL.localeCompare(TIG) == 1)
        {
            this.ShowResult("Az időpontok megadása helytelen!", 200);
            return;
        }


        var idopontitem = { DatumTol: DTOL, DatumIg: DIG, TimeTol: TTOL, TimeIg: TIG, TimeTolID: this.$refs.cboTimeTol.GetValue(), TimeIgID: this.$refs.cboTimeIg.GetValue()};

        this.Idopontok.push(idopontitem);


        this.IdopontInputMode = 0;
    },

    btnIdopontMegsem()
    {
        this.IdopontInputMode = 0;
    },

    IdopontTorles(pIndex)
    {
        this.Idopontok.splice(pIndex,1);
    },



      async Mentes()
      {
        let b = await this.CheckIdosavok();

        if (b == false) { return; }

          this.$refs.GRCDB.ShowLoading(false);

          var pIdosavok = this.GetIdosavXml();
          

        var QP = {
          sSessionID: "[APPSESSIONID]",
          iUgyfelID: this.UgyfelID,
          sIdosavok: pIdosavok,
        };
        var Q;
        await this.$refs.GRCDB.GetData("frmMolekularisDiag_Igenyles_Save", QP).then(res => { Q = res; });

        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            await this.ShowResult(Q.APPERR[0].ERR, 250);

            return;
        }

        this.$refs.GRCDB.HideLoading();

        await this.ShowResult(Q.RESULT[0].strResult, 350).then(res => 
        { 
            if (Q.RESULT[0].intResult == 1)
            {
                document.location = "dashboard";
            }
        });               

      },


      GetIdosavXml()
      {
        var res = "<NewDataSet>";
        for(var i=0; i<this.Idopontok.length; i++)
        {
            res = res 
            +"<IDOSAV>"
            + "<DatumTol>"+this.Idopontok[i].DatumTol+"</DatumTol>"
            + "<DatumIg>"+this.Idopontok[i].DatumIg+"</DatumIg>"
            + "<IdoTol>"+this.Idopontok[i].TimeTol+"</IdoTol>"
            + "<IdoIg>"+this.Idopontok[i].TimeIg+"</IdoIg>"
            +"</IDOSAV>";
        }
        res = res + "</NewDataSet>";

        return res;
      },

      async CheckIdosavok()
      {
          var res = true;

          var pIdosavok = this.GetIdosavXml();


        this.$refs.GRCDB.ShowLoading(false);

        var QP = {
          sSessionID: "[APPSESSIONID]",
          iUgyfelID: this.UgyfelID,
          sIdosavok: pIdosavok,
        };
        var Q;
        await this.$refs.GRCDB.GetData("frmMolekularisDiag_Igenyles_CheckIdosavok", QP).then(res => { Q = res; });

        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            await this.ShowResult(Q.APPERR[0].ERR, 250);

            res = false;
        }

        this.$refs.GRCDB.HideLoading();

        return res;
      },


      btnMentes()
      {
          this.Mentes();
      },


      async Init()
      {
       
        this.UgyfelID = gDashboardUgyfelID;


        this.$refs.GRCDB.ShowLoading(false);

        var QP = {
          sSessionID: "[APPSESSIONID]",
          iUgyfelID: this.UgyfelID,
        };
        var Q;
        await this.$refs.GRCDB.GetData("frmMolekularisDiag_Igenyles_Init", QP).then(res => { Q = res; });

        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            await this.ShowResult(Q.APPERR[0].ERR, 250);

            return;
        }

        this.$refs.GRCDB.HideLoading();

        this.UgyfelNev = Q.RESULT[0].UgyfelNev;
        
        if (Q.RESULT[0].IsEnabled == 0)
        {
            this.IsEnabled = 0;
            this.DisabledText = Q.RESULT[0].DisabledText;
            return;
        }

        this.IsEnabled = Q.RESULT[0].IsEnabled;

        this.$refs.cboTimeTol.SetDataSource(Q.IDOPONTOK);
        this.$refs.cboTimeIg.SetDataSource(Q.IDOPONTOK);

        this.MinDate = Q.RESULT[0].MinDate;
        this.MaxDate = Q.RESULT[0].MaxDate;

        this.$refs.txtDatumTol.SetMinMaxDate(this.MinDate, this.MaxDate);
        this.$refs.txtDatumIg.SetMinMaxDate(this.MinDate, this.MaxDate);

      },


    async ShowResult(pText, pHeight)
    {
        var DialogResult = "";
        var p = grccomp_dialog_alert_GetDefaults(grcmain_GetTextBookItem("tech", "informacio"), pText);             
        p.height = pHeight;
        p.width = 400;
        p.padding_top = -1;
        if (grccomp_getScreenSize().width < 400) { p.width = 300; }
        await this.$refs.Dialog.ShowDialog(p).then(res => 
        { 
            DialogResult = res; 
            //this.Init();
        });               
    },


  },
  created()
  {

  },
  mounted()
  {
    if (gAppInitDone)
    {
      this.SetLang();
      this.Init();
    }
  }

}


</script>


<style scoped>

.igenypage_header
{
    box-sizing: border-box;
    font-size: 15px;
    line-height: 20px;
    font-weight: normal;
    text-align: left;
    margin-bottom: 20px;

    background-color: var(--premgreen);
    color: #fff;
    font-weight: normal;
    display: inline-block;
    padding: 8px;
    border-radius: 3px;    
    margin-left: 10px;
}


.innerform_cont
{
    width:100%;
    box-sizing: border-box;
    font-size: 15px;
    line-height: 20px;
    font-weight: normal;
    text-align: left;
    padding:0px;
}

.innerform_col50
{
    width:50%;
    box-sizing: border-box;
    font-size: 15px;
    line-height: 20px;
    font-weight: normal;
    text-align: left;
    padding:0px 0px;
    vertical-align: top;
    display:inline-block;
}



.innerform_header
{
    width:100%;
    box-sizing: border-box;
    font-size: 15px;
    line-height: 20px;
    font-weight: normal;
    text-align: left;
    padding: 8px 8px;
    background-color: var(--premblue);
    color: #fff;    
    margin-bottom:20px;
    border-radius: 3px;
}

.btncont
{
  width:100%;
  box-sizing: border-box;
  text-align: center;
}

.StepProgress_cont
{
    width:100%;
    box-sizing: border-box;
    margin-bottom: 20px;
    padding:0px 8px;
}

.igeny_pageheader
{
    width:100%;
    box-sizing: border-box;
    margin-top:10px;
}

.igeny_pageheader_col1
{
    width:50%;
    box-sizing: border-box;
    display:inline-block;
    vertical-align: top;
}

.igeny_pageheader_col2
{
    width:50%;
    box-sizing: border-box;
    display:inline-block;
    vertical-align: top;
    text-align: right;
    padding-right: 8px;
    padding-top:30px;
}

.btn
{
  display: inline-block;
  font-size: 13px;
  line-height: 16px;
  font-family: 'CmsDefault';
  font-weight: normal;
  text-align: center;  
  background-color:var(--premblue);
  color:#fff;
  padding:8px 8px;
  cursor:pointer;
  border-radius: 2px;
  margin: 2px;
  min-width: 120px;

}

.btn:hover
{
  background-color: var(--premgreen);
}

.btn_icon
{
    margin-right:4px;
}

.btn_text
{
    display:inline;
}

.btn_gray
{
    background-color: #ddd;
    color: #444;;
}

.btn_gray:hover
{
    background-color: var(--premgreen);
    color: #fff;;
}




.filelist_cont {
    width: 100%;
    box-sizing: border-box;
    font-family: "CmsDefault";
    font-size: 15px;
    line-height: 18px;    
    color:var(--premblue);
    display: inline-block;
    border-bottom: solid 0px #ccc;
    padding-bottom: 4px;
    margin-bottom: 4px;
    text-align: center;
}

.file_for 
{
    width: 310px;
    box-sizing: border-box;
    display: inline-block;
    border:solid 1px #ccc;
    border-radius: 2px;
    margin:5px;
    box-shadow: rgb(221, 221, 221) 2px 2px 4px;
    position: relative;
}

.file_for:hover
{
    background-color: #f6f6f6;
}

.file_thumb
{
    width: 100%;
    cursor:pointer;
    text-align: center;
    padding: 5px;
    width:300px;
    height:220px;
    position: relative;
}

.file_footer
{
    width: 100%;
    box-sizing: border-box;
    background-color: #f0f0f0;
    border-top:solid 1px #ccc;
    height: 40px;
    padding:4px;
}

.file_filename
{
    width: 100%;
    box-sizing: border-box;
    font-size: 13px;
    line-height: 16px;
    text-align: left;
    text-overflow: ellipsis;
    white-space: nowrap;    
    overflow: hidden;
}

.file_filesize
{
    width: 100%;
    box-sizing: border-box;
    font-size: 13px;
    line-height: 16px;
    text-align: left;
    text-overflow: ellipsis;
    white-space: nowrap;    
    overflow: hidden;
}

.file_delete
{
    width:30px;
    background-color: var(--premblue);
    color: #fff;
    position:absolute;
    right:-1px;
    top:-1px;
    text-align: center;
    padding: 8px;
    font-size: 16px;
    line-height: 16px;
    border-radius: 2px;
    cursor:pointer;
    z-index: 500;
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
}

.file_delete:hover
{
    background-color: var(--premgreen);
}

.UjIdopont_cont
{
    width: 100%;
    box-sizing: border-box;
    max-width: 600px;
    margin: 0px auto;
    padding: 4px;
    border: solid 1px #ccc;
    -webkit-box-shadow: rgb(221, 221, 221) 2px 2px 4px;
    box-shadow: rgb(221, 221, 221) 2px 2px 4px;
    background-position: 0px 22px;
    border-radius: 3px;    
}

.UjIdopont_mezo
{
    width:50%;
    box-sizing: border-box;
    display: inline-block;
    vertical-align: top;
    padding: 5px;    
}

.infotext
{
    width:100%;
    box-sizing: border-box;
}

.idopont_cont
{
    width:100%;
    box-sizing: border-box;
}

.idopont_item
{
    width:100%;
    box-sizing: border-box;
    padding: 8px 4px;
    border:solid 1px #ccc;
    border-radius: 3px;
    margin-bottom: 10px;
    background-color: #f6f6f6;
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;    
    -webkit-box-shadow: #ddd 2px 2px 4px;
    box-shadow: 2px 2px 4px #ddd;    
}

.idopont_item:hover
{
    background-color: #f0f0f0;
}

.idopont_item_text
{
    width:100%;
}

.idopont_checkbox_cont
{
    width:100%;
    box-sizing: border-box;
    max-width: 2000px;
    margin-left: auto;
    margin-right: auto;
}

.igeny_pagecontent
{
    width:100%;
    box-sizing: border-box;
    margin: 0px auto;
}

.longlabel
{
    box-sizing: border-box;
    font-family: "CmsDefault", Verdana;
    font-size: 14px;
    line-height: 18px;
    color: #222;
    font-weight: bold;
    width:100%;    
}

.general_infotext
{
    width: 100%;
    box-sizing: border-box;
    font-size: 15px;
    line-height: 20px;
}

.IdopontInput_row
{
    width:100%;
    box-sizing: border-box;
    max-width: 600px;
    margin:0px auto;
}

.idopont_list_header
{
    box-sizing: border-box;
    font-size: 15px;
    line-height: 20px;
    font-weight: normal;
    text-align: left;

    background-color: var(--premgreen);
    color: #fff;
    font-weight: normal;
    display: inline-block;
    padding: 8px;
    border-radius: 3px;    
    margin-bottom: 10px;
    width:100%;
    max-width: 600px;
}


.osszesito_box_cont
{
    width:100%;
    box-sizing: border-box;
}

.osszesito_box_col
{
    width:50%;
    box-sizing: border-box;
    margin:0px;
    padding: 10px 10px 10px 0px;
    display:inline-block;
    vertical-align: top;
}

.osszesito_box_col_header
{
    width:100%;
    box-sizing: border-box;
    font-weight: 500;
}

.osszesito_box_col_content
{
    width:100%;
    box-sizing: border-box;
    font-weight: normal;
}


.igenyles_longlabel
{
    width:100%;
    box-sizing: border-box;
    font-weight: bold;
    font-size:13px;
    line-height: 16px;;
}


.ellcsop_jarobeteg_megnev
{
    text-align:left; 
    font-family:'CmsDefault'; 
    font-size:15px; 
    line-height:20px; 
    color:#222;
    padding-top: 0px; 
    height: 30px; 
    font-weight: 500;    
}

.ellcsop_jarobeteg_megnev_disabled
{
    text-align:left; 
    font-family:'CmsDefault'; 
    font-size:15px; 
    line-height:20px; 
    color:#ccc;
    padding-top: 0px; 
    height: 30px; 
    font-weight: 500;    
}

.VizsgalatInfoText
{
    width:100%;
    box-sizing: border-box;
    padding: 4px;
    border: solid 1px #ccc;
    border-radius: 3px;
    background-color: #f3f4f5;
    color: #222;
    font-size: 14px;
    line-height: 18px;    
    text-align: justify;
}

>>>.VizsgalatInfoText_Header
{
    font-size: 15px;
    line-height: 15px;
    font-weight: 500;
    color: var(--themecolor3);
    padding: 6px 6px 4px 0px;
    border-radius: 3px;
    margin: 4px 0px;    
    display:inline-block;
    box-sizing: border-box;
}

.docs_label
{
    width: 100%;
    box-sizing: border-box;
    font-weight: 500;
    text-align: center;
    color: #222;    
}

.btnEllCsopInfo
{
    font-size: 15px;
    line-height: 15px;
    color: var(--premblue);
    padding: 6px 6px 4px 6px;
    margin-left:0px;
    cursor:pointer;
}

.btnEllCsopInfo:hover
{
    color: var(--premgreen);
}


@media (max-width:800px)
{
    .innerform_cont
    {
        padding:0px;
    }

    .igeny_pageheader_col1
    {
        width:100%;
    }

    .igeny_pageheader_col2
    {
        width:100%;
        text-align: left;
    }

}

@media (max-width:670px)
{
    .filelist_cont
    {
        text-align: center;
    }

    .osszesito_box_col
    {
        width:100%;
        margin-bottom:10px;
    }

    .innerform_col50
    {
        width:100%;
    }

}



</style>